/**
 * findOverlappingCells
 *
 * Returns every cell whose `[start, end]` date range overlaps a given display
 * period's `[start, end]` range, via `rangesOverlap` (`@ooh/contracts`).
 *
 * Shared by the availability-tab grid (`availability-tab-grid.ts`'s
 * `aggregateCell`) and the client-offer-review-v2 period axis
 * (`build-review-periods.ts`'s `buildUnitHalves`) so both re-bucket a unit's
 * server-returned `AvailabilityPeriodCell[]` onto a shared display axis using
 * the exact same date-overlap rule, instead of each maintaining its own copy
 * of the same overlap loop.
 */
import { rangesOverlap } from '@ooh/contracts';

export interface PeriodRange {
  start: string;
  end: string;
}

export function findOverlappingCells<T extends PeriodRange>(cells: T[], period: PeriodRange): T[] {
  return cells.filter((cell) =>
    rangesOverlap({ from: cell.start, to: cell.end }, { from: period.start, to: period.end }),
  );
}
